export default "__VITE_ASSET__DdrGiBC3__"